define('adminColorSelectionsListView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'tableView',
  'adminColorSelectionsListToolbarView',
  'adminColorSelectionsListRowToolsView',
  'adminColorSelectionsEditPopupView',
  'entities/admin/color_selections'
], function (
  Module,
  App,
  _,
  $,
  TableView,
  ToolbarView,
  RowToolsView,
  EditPopupView
) {
  'use strict';

  var MAX_SWATCHES = 24;

  // Admin → Colour selections: the palettes an imprint technology offers in the
  // editor. An account has a handful of them, so the whole list is loaded once
  // per refresh and paged here.
  var View = TableView.extend({
    className: 'admin-color-selections-list-view ' + TableView.prototype.className,
    pageMode: 'pagination',
    pageSize: 50,
    filtersViewClass: ToolbarView,

    init: function () {
      this.search = '';
      this.items = null;
    },

    setFields: function () {
      return [{
        name: 'Code',
        label: _.i18n('admin.colorSelections.code', null, 'Code'),
        className: 'code',
        bind: 'code',
        formatter: function (value) { return _.escape(value); }
      }, {
        name: 'Name',
        label: _.i18n('admin.colorSelections.name', null, 'Name'),
        className: 'name',
        onRender: function (view) {
          var m = view.model;
          view.$el.html('<div class="cs-name">' + _.escape(m.get('name') || '') + '</div>' +
            (m.get('description') ? '<div class="cs-description">' + _.escape(m.get('description')) + '</div>' : ''));
        }
      }, {
        name: 'Colors',
        label: _.i18n('admin.colorSelections.colors', null, 'Colours'),
        className: 'colors',
        onRender: function (view) {
          var colors = view.model.get('colors') || [];
          var html = _.map(_.first(colors, MAX_SWATCHES), function (c) {
            return '<span class="cs-swatch" style="background:' + _.escape(c.hex || '#fff') + '" title="' +
              _.escape(c.code || c.hex || '') + '"></span>';
          }).join('');
          if (colors.length > MAX_SWATCHES) {
            html += '<span class="cs-more">+' + (colors.length - MAX_SWATCHES) + '</span>';
          }
          view.$el.html('<span class="cs-count">' + colors.length + '</span>' + html);
        }
      }, {
        name: 'Techniques',
        label: _.i18n('admin.colorSelections.techniques', null, 'Imprint technologies'),
        className: 'techniques',
        onRender: function (view) {
          var codes = _.map(view.model.get('techniques') || [], function (t) { return t.code; });
          view.$el.html(codes.length ? _.escape(codes.join(', ')) :
            '<span class="cs-unused">' + _.escape(_.i18n('admin.colorSelections.unused', null, 'Not used')) + '</span>');
          view.$el.attr('title', codes.join(', '));
        }
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: RowToolsView
      }];
    },

    load: function () {
      var self = this;
      if (!this.loading) {
        this.loading = App.request('colorSelections:list', this.search).done(function (items) {
          self.items = items || [];
        }).always(function () {
          self.loading = null;
        });
      }
      return this.loading;
    },

    fetch: function (first, pageSize) {
      var defer = $.Deferred();
      var self = this;
      var page = function () {
        defer.resolve(_.map((self.items || []).slice(first, first + pageSize), function (item) {
          return App.request('colorSelections:model', item);
        }));
      };
      if (first === 0 || !this.items) {
        this.load().done(page).fail(function () { defer.resolve([]); });
      } else {
        page();
      }
      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();
      var self = this;
      var count = function () { defer.resolve((self.items || []).length); };
      if (this.loading) {
        this.loading.always(count);
      } else if (this.items) {
        count();
      } else {
        this.load().always(count);
      }
      return defer.promise();
    },

    setSearch: function (search) {
      this.search = search || '';
      this.reloadAll();
    },

    onRowClick: function (rowView, e) {
      if ($(e.target).closest('.buttons').length) { return; }
      EditPopupView.open(rowView.model.get('secId'), _.bind(this.reloadAll, this));
    },

    reloadAll: function () {
      this.items = null;
      this.refresh();
    }
  });

  Module.exports = View;
});

